import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import CouponOrder2 from 'components/Coupon/CouponOrder2';
import CouponEstimate2 from 'components/Coupon/CouponEstimate2';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';
import moment from 'moment';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../_state';
import CouponDetail from '../components/ActiveCode/CouponDetail';

import TaxBillDetail from './TaxBillDetail';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'orderNo', label: '주문번호', minWidth: 150, align: 'center' },
  { id: `createdId`, label: '담당자ID', minWidth: 120, align: 'center' },
  { id: `createdName`, label: '담당자명', minWidth: 100, align: 'center' },
  { id: 'amount', label: '사용권금액', minWidth: 100, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'depositAmount', label: '결제금액', minWidth: 100, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'quantity', label: '사용권수량', minWidth: 90, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'residualQuantity', label: '남은수량', minWidth: 90, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'codeDate', label: '코드사용일', minWidth: 90, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'startDate', label: '사용 시작일', minWidth: 120, align: 'center' },
  { id: 'endDate', label: '사용 만료일', minWidth: 120, align: 'center' },
  { id: 'createdAt', label: '구매일자', minWidth: 150, align: 'center' },
  // { id: 'depositAt', label: '입금일', minWidth: 150, align: 'center' },
  // { id: 'approvalAt', label: '승인일', minWidth: 150, align: 'center' },
  { id: 'issuanceAt', label: '발급최근일자', minWidth: 150, align: 'center' },
  { id: 'prgStep', label: '진행현황', minWidth: 180, align: 'center' }
  // { id: 'cancelReqAt', label: '취소요청일자', minWidth: 150, align: 'center' }
];

export default function CouponMng() {
  const auth = useRecoilValue(authAtom);

  const date = new Date();
  const [srchData, setSrchData] = useState({
    startYmd: moment(date.getTime()).add('-1', 'y'),
    endYmd: moment()
  });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [open, setOpen] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [openEstimate, setOpenEstimate] = useState(false);
  const [orderId, setOrderId] = useState();
  const [selected, setSelected] = useState({});
  const [orderStepCdItem, setOrderStepCdItem] = useState([]);
  const [openTaxBill, setOpenTaxBill] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const handleOpenTaxBill = (row) => (e) => {
    setSelectedRow(row);
    setOpenTaxBill(true);
  };

  const getOrderStepCd = async () => {
    const response = await axios.get('/api/code/order_step');
    if (response.data) {
      setOrderStepCdItem(response.data);
    }
  };

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDetail = () => {
    setOpenDetail(false);
  };

  const handleCloseCancel = () => {
    setOpenCancel(false);
  };

  const handleClickOpenEstimate = () => {
    setOpenEstimate(true);
  };

  const handleCloseEstimate = () => {
    setOpenEstimate(false);
  };

  const handleCloseTaxBill = () => {
    setOpenTaxBill(false);
  };

  const handleRowClick = (data) => (evt) => {
    if (!!!data.approvalAt) return;
    setOrderId(data.id);
    setOpenDetail(true);
  };

  const getDataList = async (e) => {
    const { startYmd, endYmd, username } = srchData;
    if (!!!startYmd) {
      alert('발급 시작일을 입력해 주세요.');
      return;
    }
    if (!!!endYmd) {
      alert('발급 종료일을 입력해 주세요.');
      return;
    }

    let params = {
      offset,
      page,
      limit: offset,
      startYmd: startYmd.format('YYYYMMDD'),
      endYmd: endYmd.format('YYYYMMDD'),
      username
    };

    const response = await axios.get(`/api/coupon/order/${auth.companyId}`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const deposit = async (id) => {
    if (window.confirm('입금완료 후 취소할 수 없습니다. 진행하시겠습니까?')) {
      await axios
        .patch(`/api/coupon/deposit/${id}`)
        .then((response) => {
          alert(response.data.message);
          getDataList(page);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const handleClickOrderCancel = (row) => (e) => {
    e.stopPropagation();
    setSelected(row);
    setOpenCancel(true);
  };

  useEffect(() => {
    getDataList(page);
    getOrderStepCd();
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        사용권 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={{ width: '100%' }}>
          <Stack direction="row" spacing={2}>
            <LocalizationProvider dateAdapter={DateAdapter}>
              <DatePicker
                inputFormat={'yyyy-MM-DD'}
                label="발급 시작일"
                value={srchData.startYmd}
                onChange={(newValue) => {
                  setSrchData({ ...srchData, startYmd: newValue });
                }}
                renderInput={(params) => <TextField {...params} helperText={null} />}
                disableMaskedInput={true}
              />
              <DatePicker
                inputFormat={'yyyy-MM-DD'}
                label="발급 종료일"
                value={srchData.endYmd}
                onChange={(newValue) => {
                  setSrchData({ ...srchData, endYmd: newValue });
                }}
                renderInput={(params) => <TextField {...params} helperText={null} />}
                disableMaskedInput={true}
              />
            </LocalizationProvider>
            <TextField id="usernameSrch" variant="outlined" label="담당자명" value={srchData?.pgmNm || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleClickOpenEstimate} sx={{ mr: 1 }}>
              견적서 받기
            </Button>
            <Button variant="contained" onClick={handleClickOpen}>
              사용권 구매
            </Button>
          </Box>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id}>
                    {columns.map((col, colIdx) => {
                      const colId = col.id;
                      const value = row[col.id];
                      const prgStepCd = orderStepCdItem.find((t) => t.cdVal === row.prgStepCd);
                      let cellValue = value;

                      if (colId === 'prgStep') {
                        let btnInfo = prgStepCd?.cdNm ? { variant: 'contained', btnNm: prgStepCd?.cdNm } : { variant: 'outlined', btnNm: '조회' };
                        let color = 'primary';
                        if (row.prgStepCd === 'CANCEL_CMPT') {
                          color = 'info';
                        }
                        if (row?.cancelReqAt && !row?.cancelCmptAt) {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              <Button variant={btnInfo.variant} onClick={handleOpenTaxBill(row)} fullWidth color="error">
                                주문취소요청
                              </Button>
                            </TableCell>
                          );
                        }
                        if (row.companionAt) {
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              <Button variant={btnInfo.variant} onClick={handleOpenTaxBill(row)} fullWidth color="warning">
                                {btnInfo?.btnNm}
                              </Button>
                            </TableCell>
                          );
                        } else {
                          const cdVal = prgStepCd?.cdVal;
                          let btnNm = btnInfo?.btnNm;
                          if (cdVal === '002') {
                            btnNm = '주문확인';
                          }
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              <Button variant={btnInfo.variant} onClick={cdVal === 'FREE' ? null : handleOpenTaxBill(row)} fullWidth color={color}>
                                {btnNm}
                              </Button>
                            </TableCell>
                          );
                        }
                      }

                      if ((colId === 'startDate' || colId === 'endDate') && row.prgStepCd !== '800') {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            -
                          </TableCell>
                        );
                      }

                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {col.format && typeof cellValue === 'number' ? col.format(cellValue) : cellValue}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={(e, value) => setPage(value)} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
      </Grid>
      <CouponOrder2 open={open} handleClose={handleClose} getDataList={getDataList} />
      <CouponDetail open={openDetail} handleClose={handleCloseDetail} companyId={auth.companyId} orderId={orderId} />
      <CouponEstimate2 open={openEstimate} handleClose={handleCloseEstimate} getDataList={getDataList} />
      {selectedRow?.id && <TaxBillDetail companyId={selectedRow?.companyId} orderId={selectedRow?.id} open={openTaxBill} handleClose={handleCloseTaxBill} getDataList={getDataList} page={page} prgStepItems={orderStepCdItem} />}
    </Paper>
  );
}
